import React, { useState } from 'react';
import CategoryPage from './components/CategoryPage';
import WritePage from './components/WritePage';
import RitualPage from './components/RitualPage';
import DonePage from './components/DonePage';
import AboutPage from './components/AboutPage';
import PaperBackground from './components/ui/PaperBackground';

function App() {
  const [currentView, setCurrentView] = useState('select');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [paperData, setPaperData] = useState({ content: '' });
  const [aboutScrollTarget, setAboutScrollTarget] = useState(null);

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setCurrentView('write');
  };

  const handleBackToSelect = () => {
    setCurrentView('select');
  };

  const handleSend = (data) => {
    setPaperData(data);
    setCurrentView('ritual');
  };

  const handleRitualComplete = () => {
    setCurrentView('done');
    setPaperData({ content: '' });
  };

  const handleReset = () => {
    setSelectedCategory(null);
    setCurrentView('select');
  };

  // 接收 target 參數來判斷要捲動到哪裡
  const handleAbout = (target = null) => {
    setAboutScrollTarget(target);
    setCurrentView('about');
  };

  const showPaperBackground = ['select', 'write', 'about'].includes(currentView);

  return (
    <div 
      className="relative w-full h-full bg-paper flex items-center justify-center overflow-hidden"
      style={{
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'env(safe-area-inset-bottom)',
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)'
      }}
    >
      {showPaperBackground && <PaperBackground />}
      
      {currentView === 'select' && (
        <CategoryPage onSelect={handleCategorySelect} onAbout={handleAbout} />
      )}
      
      {currentView === 'write' && (
        <WritePage 
          onSend={handleSend} 
          initialData={paperData} 
          category={selectedCategory}
          onBack={handleBackToSelect}
        />
      )}
      
      {currentView === 'ritual' && (
        <RitualPage data={paperData} onComplete={handleRitualComplete} />
      )}
      
      {currentView === 'done' && (
        <DonePage category={selectedCategory} onReset={handleReset} onAbout={handleAbout} />
      )}

      {currentView === 'about' && (
        <AboutPage 
          onBack={handleBackToSelect} 
          scrollToSupport={aboutScrollTarget === 'support'} 
        />
      )}
    </div>
  );
}

export default App;